module.exports = __webpack_public_path__ + "static/media/sys-admin.d68a2b74.svg";